var ShareDocument = /** @class */ (function () {
    function ShareDocument(container) {
        this.container = container || document.querySelector('.documents-page');
        this.shareButtons = this.container
            ? Array.from(this.container.querySelectorAll('[data-share-document]'))
            : [];
        this.resetTimeouts = new WeakMap();
        this.addEventListeners();
    }
    ShareDocument.prototype.addEventListeners = function () {
        var _this = this;
        this.shareButtons.forEach(function (shareButton) {
            shareButton.addEventListener('click', _this.shareDocument.bind(_this));
        });
    };
    ShareDocument.prototype.shareDocument = function (event) {
        var _this = this;
        var currentTarget = event.currentTarget;
        var documentUrl = currentTarget.dataset.shareDocument;
        if (!documentUrl) {
            return;
        }
        // Absolute url so the copied value works when pasted anywhere
        var shareUrl = new URL(documentUrl, window.location.href).href;
        this.copyToClipboard(shareUrl)
            .then(function () { return _this.showCopiedState(currentTarget); })
            .catch(function (error) { return console.error('Copy error:', error); });
    };
    ShareDocument.prototype.copyToClipboard = function (value) {
        // Clipboard api needs a secure context - fall back to a temporary textarea
        if (navigator.clipboard && window.isSecureContext) {
            return navigator.clipboard.writeText(value);
        }
        return new Promise(function (resolve, reject) {
            var textarea = document.createElement('textarea');
            textarea.value = value;
            textarea.setAttribute('readonly', '');
            textarea.style.position = 'fixed';
            textarea.style.opacity = '0';
            document.body.appendChild(textarea);
            textarea.select();
            try {
                document.execCommand('copy') ? resolve() : reject(new Error('Copy command was rejected'));
            }
            catch (error) {
                reject(error);
            }
            finally {
                document.body.removeChild(textarea);
            }
        });
    };
    ShareDocument.prototype.showCopiedState = function (shareButton) {
        var _this = this;
        var label = shareButton.querySelector('.action-item-label');
        var copiedLabel = shareButton.dataset.shareCopiedLabel;
        var previousTimeout = this.resetTimeouts.get(shareButton);
        if (previousTimeout) {
            // Button clicked again before the previous state reset
            clearTimeout(previousTimeout);
        }
        else if (label && copiedLabel) {
            shareButton.dataset.shareDefaultLabel = label.textContent;
            label.textContent = copiedLabel;
        }
        shareButton.classList.add('copied');
        var timeoutId = window.setTimeout(function () {
            if (label && shareButton.dataset.shareDefaultLabel) {
                label.textContent = shareButton.dataset.shareDefaultLabel;
            }
            shareButton.classList.remove('copied');
            _this.resetTimeouts.delete(shareButton);
        }, 2000);
        this.resetTimeouts.set(shareButton, timeoutId);
    };
    return ShareDocument;
}());
export default ShareDocument;
